export default __webpack_public_path__ + "static/media/test.2d361405.mp3";